import React, { Component, Dispatch } from 'react';
import { Log } from 'ng2-logger';
import Translator from '../../../core/i18n';
import { Common } from '../../../core/common';
import { IAction, IAppState } from '../../../models/action/core';
import { connect } from 'react-redux';
import { IOrderingProps, IOrderingState } from '../../../models/components/add-question';
import { FileService } from '../../../api/file-service';
import { Confirm, Notification } from '../../../components/notification/main';
import { BaseFields } from './baseFields';
import { IQuestionChoice, IQuestionData } from '../../../models/components/questions';
import { FormikProps } from 'formik';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import ReactDOM from 'react-dom';
import { FileChoice } from '../../../components/input/choice/file-choice';
import { TextChoice } from '../../../components/input/choice/text-choice';

const T = Translator.create();
const _logger = Log.create('Ordering');
let _common: Common;
const _fileService = new FileService();
const portal = document.createElement('div');
document.body.appendChild(portal);

class Ordering extends Component<IOrderingProps, IOrderingState> {
    constructor(props: any) {
        super(props);
        _common = new Common();

        this.state = {
            questionListPadding: 10,
            textChoices: [],
            fileChoices: []
        };
    }

    public onChangeQuestionChoiceType = (selectValue: 0 | 1, formik: FormikProps<IQuestionData>) => {
        if (formik.values.isExamQuestion) {
            Notification.setNotification(
                'error',
                T.t('r_api_gen_question_error_not_editable_exam_question'),
                'topRight'
            );
            return;
        }
        formik.setFieldValue('questionChoiceType', selectValue);

        if (selectValue) {
            this.setState({ textChoices: formik.values.choices });
            formik.setFieldValue('choices', this.state.fileChoices);
        } else {
            this.setState({ fileChoices: formik.values.choices });
            formik.setFieldValue('choices', this.state.textChoices);
        }
    };

    public addChoices = (formik: FormikProps<IQuestionData>) => {
        if (formik.values.isExamQuestion) {
            Notification.setNotification(
                'error',
                T.t('r_api_gen_question_error_not_editable_exam_question'),
                'topRight'
            );
            return;
        }
        let endIndex = 0;
        let endDisplayOrder = 0;
        if (formik.values.choices.length > 0) {
            endIndex = formik.values.choices.sort((a, b) => b.sortOrder - a.sortOrder)[0].sortOrder + 1;
            endDisplayOrder = formik.values.choices.sort((a, b) => b.displayOrder - a.displayOrder)[0].displayOrder + 1;
        }

        const _choiceList = formik.values.choices.sort((a, b) => a.sortOrder - b.sortOrder);
        const item: IQuestionChoice = {
            inputId: '',
            choiceFileId: '',
            choiceFile: '',
            isCorrect: false,
            choiceText: '',
            optionText: String.fromCharCode(64 + formik.values.choices.length + 1),
            fileInputKey: this.props.fileInputKey + endIndex,
            displayOrder: endDisplayOrder,
            side: 0,
            sortOrder: endIndex
        };

        _choiceList.push(item);
        formik.setFieldValue('choices', _choiceList);
    };

    deleteChoice = (choice: IQuestionChoice) => {
        if (this.props.formik.values.isExamQuestion) {
            Notification.setNotification(
                'error',
                T.t('r_api_gen_question_error_not_editable_exam_question'),
                'topRight'
            );
            return;
        }
        Confirm.setConfirm(
            'normal',
            () => this.deleteConfirmed(choice.sortOrder),
            T.t('r_delete_question_choice'),
            null,
            null,
            undefined,
            true
        );
    };

    deleteConfirmed = (sortOrder: number) => {
        const _choiceList = this.props.formik.values.choices.sort((a, b) => a.sortOrder - b.sortOrder);
        const sourceItemIndex = _choiceList.findIndex(q => q.sortOrder === sortOrder);

        if (sourceItemIndex !== -1) {
            _choiceList.splice(sourceItemIndex, 1);
            _choiceList.filter(q => q.sortOrder >= sortOrder).forEach((item) => {
                item.sortOrder = item.sortOrder - 1;
                item.optionText = String.fromCharCode(64 + item.sortOrder + 1);
            });
            this.props.formik.setFieldValue('choices', _choiceList);
        }
    };

    reorder = (startIndex: number, endIndex: number) => {
        const _choiceList = this.props.formik.values.choices.sort((a, b) => a.sortOrder - b.sortOrder);
        const sourceItem = _choiceList.find(q => q.sortOrder === startIndex);
        const sourceItemIndex = _choiceList.findIndex(q => q.sortOrder === startIndex);

        if (sourceItem) {
            _choiceList.splice(sourceItemIndex, 1);

            if (sourceItem.sortOrder < endIndex) {
                _choiceList
                    .filter(q => q.sortOrder <= endIndex && q.sortOrder > startIndex).forEach((item) => {
                        item.sortOrder = item.sortOrder - 1;
                        item.optionText = String.fromCharCode(64 + item.sortOrder + 1);
                    });
            } else if (sourceItem.sortOrder > endIndex) {
                _choiceList
                    .filter(q => q.sortOrder < startIndex && q.sortOrder >= endIndex).forEach((item) => {
                        item.sortOrder = item.sortOrder + 1;
                        item.optionText = String.fromCharCode(64 + item.sortOrder + 1);
                    });
            }

            sourceItem.sortOrder = endIndex;
            sourceItem.optionText = String.fromCharCode(64 + endIndex + 1);
            _choiceList.push(sourceItem);
            this.props.formik.setFieldValue('choices', _choiceList);
        }
    };

    public onDragEnd = (result: any) => {
        this.setState({ questionListPadding: 10 });

        const res = result;
        if (!res.destination) {
            return;
        }

        const sourceItem = this.props.formik.values.choices.sort((a, b) => a.sortOrder - b.sortOrder)[res.source.index];
        const destinationItem = this.props.formik.values.choices.sort((a, b) => a.sortOrder - b.sortOrder)[res.destination.index];

        if (res.source.droppableId === res.destination.droppableId && sourceItem && destinationItem) {
            this.reorder(sourceItem.sortOrder, destinationItem.sortOrder);
        }
    };

    public onDragStart = (result: any) => {
        const item = document.getElementById('choices_' + result.source.index);
        if (item) {
            this.setState({ questionListPadding: item.clientHeight + 10 });
        }
    };

    public choiseInputOnChange = (e: any, choice: IQuestionChoice, formik: FormikProps<IQuestionData>) => {
        if (e) {
            const choices = formik.values.choices;
            if (choices.length > 0) {
                const _choice = choices.find(x => x.sortOrder === choice.sortOrder);
                if (_choice) {
                    _choice.choiceText = e;
                    this.editChoice(_choice, formik);
                }
            }
        }
    }

    public editChoice = (choice: IQuestionChoice, formik: FormikProps<IQuestionData>) => {
        const _choiceList = formik.values.choices.sort((a, b) => a.sortOrder - b.sortOrder);
        if (_choiceList.length > 0) {
            const sourceItemIndex = _choiceList.findIndex(q => q.sortOrder === choice.sortOrder);
            if (sourceItemIndex !== -1) {
                _choiceList.splice(sourceItemIndex, 1);
                _choiceList.push(choice);
                formik.setFieldValue('choices', _choiceList);
            }
        }
    };

    componentDidMount() {
        if (this.props.formik && this.props.formik.values && this.props.formik.values.choices) {
            this.props.formik.values.choices.forEach(choice => {
                if (choice.choiceFile && choice.choiceFileId) {
                    void _common.GetImageUrl(choice.choiceFile).then((url: any) => {
                        choice.fileInputKey = this.props.fileInputKey + choice.sortOrder;
                        choice.isPreviewFile = true;
                        choice.file = url;
                        this.editChoice(choice, this.props.formik);
                        this.props.formik.setFieldValue('questionChoiceType', 1);
                    });
                }
            });
        }
    }

    triggerModal = (choice: IQuestionChoice, formik: FormikProps<IQuestionData>, value: boolean) => {
        if (formik && formik.values) {
            const choices = formik.values.choices;
            const _choice = choices.find(x => x.sortOrder === choice.sortOrder);
            if (_choice) {
                _choice.isModalOpen = value;
                this.editChoice(_choice, formik);
            }
        }
    }

    getFileAsync = async (fileName: string, choice: IQuestionChoice, formik: FormikProps<IQuestionData>, fileInputKey: string) => {
        const params = { fileUploadId: fileInputKey, fileName };
        const choices = formik.values.choices;
        const _choice = choices.find(x => x.sortOrder === choice.sortOrder);

        if (_choice) {
            await _fileService
                .RequestGetFileAsync({ ...params })
                .then((response: Response) => {
                    if (response.status !== 200) {
                        _choice.isPreviewFile = false;
                        _choice.file = '';
                        this.editChoice(_choice, formik);
                    }
                    return response.json();
                })
                .then((responseData: any) => {
                    _choice.isPreviewFile = true;
                    _choice.file = responseData;
                    this.editChoice(_choice, formik);
                    this.triggerModal(choice, formik, false);
                })
                .catch(() => {
                    _choice.isPreviewFile = false;
                    _choice.file = 'responseData';
                    this.editChoice(_choice, formik);
                });
        }
    };

    afterFileUploadChoice = async (file: any, choice: IQuestionChoice, formik: FormikProps<IQuestionData>, fileInputKey: string) => {
        if (formik && formik.values) {
            const choices = formik.values.choices;
            const _choice = choices.find(x => x.sortOrder === choice.sortOrder);

            if (file && _choice) {
                _choice._file = file;
                this.editChoice(_choice, this.props.formik);
                await this.getFileAsync(file.name, choice, formik, fileInputKey);
            }
        }
    }

    afterFileDeleteChoice = async (choice: IQuestionChoice, formik: FormikProps<IQuestionData>) => {
        if (formik && formik.values) {
            const choices = formik.values.choices;
            const _choice = choices.find(x => x.sortOrder === choice.sortOrder);

            if (_choice) {
                _choice.isPreviewFile = false;
                _choice.file = '';
                this.editChoice(_choice, this.props.formik);
            }
        }
    }

    public handleDeleteFileConfirm = (choice: IQuestionChoice, formik: FormikProps<IQuestionData>) => {
        if (formik.values.isExamQuestion) {
            Notification.setNotification(
                'error',
                T.t('r_api_gen_question_error_not_editable_exam_question'),
                'topRight'
            );
            return;
        }
        Confirm.setConfirm('normal', () => this.handleDeleteFile(choice.sortOrder, formik), T.t('r_confirm_delete_photo'), null, null, undefined, true);
    };

    handleDeleteFile = (sortOrder: number, formik: FormikProps<IQuestionData>) => {
        const choices = formik.values.choices;
        const choice = choices.find(x => x.sortOrder === sortOrder);

        if (choice) {
            if (choice._file) {
                choice.willDeleteFile = choice._file;
            } else {
                choice.isPreviewFile = false;
                choice.file = '';
                this.props.formik.setFieldValue('questionFileId', '');
            }
            this.editChoice(choice, this.props.formik);
        }
    }

    choicesPortalAwareItem = (provided: any, snapshot: any, choice: IQuestionChoice, index: number) => {
        const usePortal = snapshot.isDragging;
        let child;

        switch (this.props.formik && this.props.formik.values && this.props.formik.values.questionChoiceType) {
            case 0:
                child = (
                    <TextChoice
                        provided={provided}
                        index={index}
                        choice={choice}
                        formik={this.props.formik}
                        choiseInputOnChange={this.choiseInputOnChange}
                        deleteChoice={this.deleteChoice}
                        readonly={this.props.formik.values.isExamQuestion}
                    />
                );
                break;
            case 1:
                child = (
                    <FileChoice
                        provided={provided}
                        index={index}
                        choice={choice}
                        formik={this.props.formik}
                        choiseInputOnChange={this.choiseInputOnChange}
                        deleteChoice={this.deleteChoice}
                        triggerModal={this.triggerModal}
                        handleDeleteFileConfirm={this.handleDeleteFileConfirm}
                        afterFileUploadChoice={this.afterFileUploadChoice}
                        afterFileDeleteChoice={this.afterFileDeleteChoice}
                        readonly={this.props.formik.values.isExamQuestion}
                    />
                );
                break;
            default:
                break;
        }

        if (!usePortal) {
            return child;
        }

        return ReactDOM.createPortal(child, portal);
    };

    public render() {
        return (
            <div id="st4" className="col">
                <BaseFields formik={this.props.formik} isFromMadlen={this.props.isFromMadlen} fileInputKey={this.props.fileInputKey} />

                {!this.props.isFromMadlen &&
                    <>
                        <div className="row mt-4">
                            <div className="col-12">
                                <span className="new-subtitle">{T.t('r_gen_questionBank_choise_type')} <span className="ml-1" style={{ color: '#dc5050' }}>* </span></span>
                            </div>
                            <div className="col-md-12 col-12 difficulties" style={{ marginTop: 20 }}>
                                <div className="control_group survey_choose mr-4">
                                    <label
                                        className="control control--radio"
                                        htmlFor={T.t('r_gen_questionBank_choise_type_text')}
                                        onClick={this.onChangeQuestionChoiceType.bind(this, 0, this.props.formik)}
                                    >
                                        {T.t('r_gen_questionBank_choise_type_text')}
                                        <input
                                            type="checkbox"
                                            name={'choiseType'}
                                            value={0}
                                            checked={this.props.formik && this.props.formik.values && this.props.formik.values.questionChoiceType === 0}
                                            className="form-radio"
                                            style={{ borderRadius: 100 }}
                                        />
                                        <div className="control__indicator" />
                                    </label>
                                </div>
                                {/* <div className="control_group survey_choose mr-4">
                            <label
                                className="control control--radio"
                                htmlFor={T.t('r_gen_questionBank_choise_type_photo')}
                                onClick={this.onChangeQuestionChoiceType.bind(this, 1, this.props.formik)}
                            >
                                {T.t('r_gen_questionBank_choise_type_photo')}
                                <input
                                    type="checkbox"
                                    name={'choiseType'}
                                    value={1}
                                    id={'Fotograf'}
                                    checked={this.props.formik && this.props.formik.values && this.props.formik.values.questionChoiceType === 1}
                                    className="form-radio"
                                    style={{ borderRadius: 100 }}
                                />
                                <div className="control__indicator" />
                            </label>
                        </div> */}
                            </div>
                        </div>
                        <DragDropContext onDragEnd={this.onDragEnd} onDragStart={this.onDragStart}>
                            <Droppable isDropDisabled={this.props.formik.values.isExamQuestion} droppableId="choices">
                                {(_provided, _snapshot) => (
                                    <div
                                        className="row"
                                        ref={_provided.innerRef}
                                        style={{ paddingBottom: this.state.questionListPadding }}
                                    >
                                        {this.props.formik.values.choices
                                            .sort((a, b) => a.sortOrder - b.sortOrder)
                                            .map((item, index) => (
                                                <Draggable key={index} isDragDisabled={this.props.formik.values.isExamQuestion} draggableId={index.toString()} index={index}>
                                                    {(provided, snapshot) => (
                                                        <React.Fragment>
                                                            {this.choicesPortalAwareItem(
                                                                provided,
                                                                snapshot,
                                                                item,
                                                                index
                                                            )}
                                                        </React.Fragment>
                                                    )}
                                                </Draggable>
                                            ))}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                        <div className="row mt-4">
                            <div className="col-12" style={{ padding: 0 }}>
                                <div className="col-12 answerText">
                                    <a
                                        // tslint:disable-next-line
                                        onClick={this.addChoices.bind(this, this.props.formik)}
                                        className="attachment-btn"
                                        type="button"
                                        aria-expanded="false"
                                    >
                                        <i className="material-icons mr-2">add</i>
                                        {T.t('r_gen_questionBank_newChoise')}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </>
                }
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IOrderingProps): IOrderingProps => {
    if (!state) {
        return ownProps;
    }

    const newProps: IOrderingProps = Object.assign({}, ownProps, {
        coursePageActivityId: state.coursePage.coursePageActivityId,
        coursePageClassId: state.coursePage.coursePageClassId
    });

    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret =
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId;
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const COrdering = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(Ordering);

export default COrdering;
